import styled from 'styled-components';

export const NotificationSystemStyled = styled.div`
  .notifications-wrapper {
    position: fixed !important;
    top: 0 !important;
    right: 0 !important;
    z-index: 9998 !important;
    transform: translateZ(0);
  }

  @media (max-width: 500px) {
    .notifications-wrapper {
      width: 100% !important;
    }
  }
`;
